module.exports = {
  index: {
    title: "首页",
    noLoginRequired: true,
    requiredParams: {},
    optionalParams: {}
  },
  goodsSettleResult: {
    title: "购买结果",
    requiredParams: {},
    optionalParams: {
      orderNo: "订单编号"
    }
  },
  convertSuccess: {
    title: "兑换成功",
    requiredParams: {
      id: "卡券的Id"
    },
    optionalParams: {
      // orderNo: "订单编号"
    }
  },
  goodsSettle: {
    title: "商品结算",
    requiredParams: {
      courseId: "课程id"
    },
    optionalParams: {
      isConvert: "bool值，是否是兑换tab"
    }
  },
  convert: {
    title: "商品兑换",
    requiredParams: {
      courseId: "课程id"
    },
    optionalParams: {}
  },
  goodsDetails: {
    title: "商品详情",
    requiredParams: {
      id: "商品id或者课程id"
    },
    optionalParams: {}
  },
  joinOrg: {
    title: "加入医院",
    requiredParams: {},
    optionalParams: {}
  },
  infoCollect: {
    title: "完善信息",
    requiredParams: {},
    optionalParams: {}
  }
};
